export default "__VITE_ASSET__DmKEw0jd__"